import React, { FC } from 'react';
import { TOverviewCarouselIndicatorsProps } from '../../types/overviewCarousel.types';

const OverviewCarouselIndicators: FC<TOverviewCarouselIndicatorsProps> = ({
  numOfSlides,
  currentSlideIndex,
  customClass = '',
  onClick,
}) => {
  const items: Array<number> = Array(numOfSlides).fill(null);

  return (
    <ul className="series-overview-carousel__indicators">
      {items.map((_, index) => (
        <li
          onClick={(): void => onClick?.(index)}
          className={`series-overview-carousel__indicators__item${
            index === currentSlideIndex ? ' series-overview-carousel__indicators__item--active' : ''
          } ${customClass}`}
          key={`overview-slider-indicators-item-${index}`}
        ></li>
      ))}
    </ul>
  );
};

export default OverviewCarouselIndicators;
